import { InternalSignUpAction, InternalSignUpActions } from '../actions/internalSignUp.action';

export interface InternalSignUpState {
  isLoading: boolean;
  success: boolean;
  errorText: string;
}

const initialState: InternalSignUpState = {
  isLoading: false,
  success: false,
  errorText: '',
};

export default (state: InternalSignUpState = initialState, action: InternalSignUpAction) => {
  switch (action.type) {
    case InternalSignUpActions.InternalSignUpRequest:
      return {
        ...state,
        isLoading: true,
        success: false,
        errorText: '',
      };
    case InternalSignUpActions.InternalSignUpSuccess:
      return {
        ...state,
        isLoading: false,
        success: true,
        errorText: '',
      };
    case InternalSignUpActions.InternalSignUpFailed:
      return {
        ...state,
        isLoading: false,
        success: false,
        errorText: action.payload,
      };
    default:
      return state;
  }
};
